__turbopack_context__.v({
  "cta-subtitle": "subscription-sticky-footer-cta-module-scss-module__NSgt4W__cta-subtitle",
  "subscription-cta": "subscription-sticky-footer-cta-module-scss-module__NSgt4W__subscription-cta",
});
